// Toggle a popover anchored to a trigger. Closes on outside click and Escape; restores focus.
export function wirePopover(trigger, panel, { onOpen } = {}) {
  const open = () => {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    onOpen?.();
    document.addEventListener('mousedown', outside, true);
    document.addEventListener('keydown', onKey, true);
  };
  const close = (restoreFocus = false) => {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('mousedown', outside, true);
    document.removeEventListener('keydown', onKey, true);
    if (restoreFocus) trigger.focus();
  };
  const outside = (e) => { if (!panel.contains(e.target) && !trigger.contains(e.target)) close(); };
  const onKey = (e) => { if (e.key === 'Escape') { e.preventDefault(); close(true); } };

  trigger.setAttribute('aria-expanded', 'false');
  trigger.addEventListener('click', () => (panel.hidden ? open() : close()));
  panel.addEventListener('click', (e) => { if (e.target.closest('a[href], [data-close-popover]')) close(); });
  return { open, close };
}
